@if (visible && transaction) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-panel" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <div class="user-avatar-lg">
            @if (transaction.userInfo.profilePhoto) {
              <img
                [src]="transaction.userInfo.profilePhoto"
                [alt]="getDisplayName()"
                class="avatar-img" />
            }
            @if (!transaction.userInfo.profilePhoto) {
              <span>{{ getInitials() }}</span>
            }
          </div>
          <div>
            <h3 class="modal-title">{{ getDisplayName() | titlecase}}</h3>
            <p class="modal-subtitle">{{ transaction.userInfo.email || 'N/A' }}</p>
          </div>
        </div>
        <button class="close-btn" (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <!-- Status + Payment Type Row -->
        <div class="badges-row">
          <span class="status-badge completed">
            Completed
          </span>
          <span class="type-badge">
            {{ transaction.type | titlecase }}
          </span>
          <span class="payment-type-badge">
            {{ resolvePaymentType().label }}
          </span>
        </div>

        <!-- Info Grid -->
        <div class="info-grid">
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-dollar"></i></div>
            <div>
              <p class="info-label">Amount</p>
              <p class="info-value text-success">{{ transaction.amountFormatted }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-calendar"></i></div>
            <div>
              <p class="info-label">Date &amp; Time</p>
              <p class="info-value">{{ transaction.createdAt | date: 'MMM d, yyyy, h:mm a' }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-wallet"></i></div>
            <div>
              <p class="info-label">Balance Before</p>
              <p class="info-value">${{ transaction.balanceBefore | number: '1.2-2' }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-money-bill"></i></div>
            <div>
              <p class="info-label">Balance After</p>
              <p class="info-value">${{ transaction.balanceAfter | number: '1.2-2' }}</p>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="description-section">
          <h4 class="section-title"><i class="pi pi-info-circle"></i> Description</h4>
          <p class="description-text">{{ transaction.description || 'No description provided' }}</p>
        </div>

        <!-- Metadata / External IDs -->
        <div class="meta-section">
          @if (transaction.stripePaymentIntentId) {
            <div class="meta-row">
              <span class="meta-label">Stripe Payment Intent ID:</span>
              <code class="meta-value">{{ transaction.stripePaymentIntentId }}</code>
            </div>
          }
          @if (transaction.relatedLobbyId) {
            <div class="meta-row">
              <span class="meta-label">Related Lobby ID:</span>
              <code class="meta-value">{{ transaction.relatedLobbyId }}</code>
            </div>
          }
          <div class="meta-row">
            <span class="meta-label">Transaction ID:</span>
            <code class="meta-value">{{ transaction._id }}</code>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer" style="display: flex; gap: 0.75rem; justify-content: flex-end;">
        @if (!transaction.deletedAt) {
          <button class="btn-action-reject" (click)="onRefund()" [disabled]="isRefundDisabled">Refund</button>
        }
        <button class="btn-close-footer" (click)="close()">Close</button>
      </div>

    </div>
  </div>
}
